var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"core-footer"},[_c('v-container',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"mr-0 font-weight-light pt-md-0 text-center",attrs:{"col":"12"}},[_vm._v(" © 2022 - "+_vm._s(new Date().getFullYear())+", "+_vm._s(_vm.$t("footer-title"))+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }